import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useJwt } from "react-jwt";
import  secureLocalStorage  from  "react-secure-storage";

interface ProtectedRouteProps {
  requiredRole: string;
}

export interface Claims {
  role: {
    name: string;
  };
}

const ProtectedRouteAdmin = ({ requiredRole }: ProtectedRouteProps) => {
  const location = useLocation();
  const storageToken = secureLocalStorage.getItem("token");
  const token = typeof storageToken === "string" ? storageToken : null;
  
  const { decodedToken, isExpired } = useJwt<Claims>(token || "");

  if (!decodedToken) {
    return null;
  }
  
  if (!token || isExpired) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (decodedToken?.role.name !== requiredRole) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default ProtectedRouteAdmin;
